import React from 'react';

export default function BattedBallBases({
  current_runners,
}: {
  current_runners: boolean[];
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 30 30"
    >
      <polygon
        points="5,18 9,14 13,18 9,22"
        fill={current_runners[0] ? '#FEFDFA' : 'none'}
        stroke="#FEFDFA"
        stroke-width="1.5"
        stroke-linejoin="round"
      />

      <polygon
        points="11,12 15,8 19,12 15,16"
        fill={current_runners[1] ? '#FEFDFA' : 'none'}
        stroke="#FEFDFA"
        stroke-width="1.5"
        stroke-linejoin="round"
      />

      <polygon
        points="17,18 21,14 25,18 21,22"
        fill={current_runners[2] ? '#FEFDFA' : 'none'}
        stroke="#FEFDFA"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  );
}
